import moment from "moment";
import { InputText } from "primereact/inputtext";

export const DEFAULT_TIMEZONE = "America/New_York";

export const formatDate = function (date: any) {
  return date ? moment.utc(date).format("DD MMM YYYY") : null;
};

// format without utc
export const formatdate = (date: Date) => {
  if (!date) return null;
  return moment(date).format("DD MMM YYYY");
};

export const formatDateTime = function (date: any) {
  return date ? moment.utc(date).format("DD MMM YYYY, hh:mm A") : null;
};

// give day
export const formatDay = function (date: any) {
  return date ? moment.utc(date).format("dddd") : null;
};

// month and year
export const formatMonthYear = function (date: any) {
  return date ? moment.utc(date).format("MMMM YYYY") : null;
};

//Date Convert To YYYY/MM/DD
export function convertDateFrom(date: any) {
  date = new Date(date); //Date pass
  let day = date.getDate();
  let month = date.getMonth() + 1;
  let year = date.getFullYear();

  return (
    year +
    "-" +
    (month <= 9 ? "0" + month : month) +
    "-" +
    (day <= 9 ? "0" + day : day)
  );
}

// global datatable name filter
export const globalNameFilterTemplate = (options: any) => {
  const filterFieldPlaceholder = options.field
    .split("_")
    .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
  return (
    <InputText
      value={options.value || ""}
      onChange={(e) => options.filterCallback(e.target.value)}
      placeholder={"Search by " + filterFieldPlaceholder}
      className="p-column-filter"
    />
  );
};

export const globalDateTemplate = (rowData: any, rowIndex: any) => {
  return (
    <>
      <div>{formatDate(rowData[rowIndex.field])}</div>
    </>
  );
};

export const currencyBodyTemplate = (rowData: any, rowIndex: any) => {
  const value = rowData[rowIndex.field];
  return value != null ? `$${Number(value).toFixed(2)}` : "-";
};